import axiosInstance, { URLS } from "../axios_instance";
import { DynamicDocumentTokenParams } from "./interfaces/azure_https.interface";

const AZURE_URI = URLS.AZURE_URI;

export const getDynamicDocumentToken = (params: DynamicDocumentTokenParams) =>
  axiosInstance.get(`${AZURE_URI}/signedUrl/get-dynamic-document-token`, { params });

export const uploadProfilePicture = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post(`${AZURE_URI}/signedUrl/upload-profile-picture`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadPrescriptionFile = (file: File, beneficiaryId: string, fileName: string) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("docFolder", `prescriptions/${beneficiaryId}`);
  formData.append("docName", fileName);
  return axiosInstance.post(`${AZURE_URI}/signedUrl/dynamic-upload-document`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
